export const nf = new Intl.NumberFormat('ru-RU');

export function gb(v: number): string {
  return `${(Math.round(v * 10) / 10).toFixed(1).replace('.', ',')} ГБ`;
}

export function mb(v: number): string {
  return `${nf.format(Math.round(v))} МБ`;
}

export function sizeStr(m: number): string {
  return m >= 1024 ? gb(m / 1024) : mb(m);
}

export function esc(s: unknown): string {
  return String(s).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c,
  );
}

export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 16).replace('T', ' ');
  return d.toISOString().slice(0, 16).replace('T', ' ');
}

export function fmtShortDate(iso: string | null | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso ?? ''));
  if (match) return `${match[3]}.${match[2]}`;
  const d = new Date(iso ?? '');
  if (Number.isNaN(d.getTime())) return '—';
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function hhmmss(d = new Date()): string {
  return [d.getHours(), d.getMinutes(), d.getSeconds()].map((v) => String(v).padStart(2, '0')).join(':');
}

export function errText(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
